export default {
  title: 'HiTeach Classroom Games',
  pvpGame: 'Sweeping Stars',
  moleGame: 'Whack-a-Mole',
  tfGame: 'Rocket Launch',
  pickGame: 'Spin the Wheel',
  punchBoardGame: 'Punch Board',
  moreManagement: 'More Game Management',
  snakeGame: 'Vocabulary Snake',
  mazeGame: 'Maze',

  // Game info title
  gameInfoTitle: 'Game Information',
  close: 'Close',
  
  // Vocabulary Drop description
  pvpGameTitle: 'Sweeping Stars',
  pvpGameDesc: 'On a tropical island, words fall from the sky like meteor showers!\nTwo players must catch correct words and avoid wrong ones within a time limit. Who can become the vocabulary hunter king with speed and precision?',
  
  // Whack-a-Mole description
  moleGameTitle: 'Whack-a-Mole',
  moleGameDesc: 'Single player battle! The knowledge version of Whack-a-Mole is here~\nMoles pop up with true and false information. Can you accurately "knock out" the correct answers in the shortest time and defeat those troublesome errors?',
  
  // Rocket Launch description
  tfGameTitle: 'Rocket Launch',
  tfGameDesc: 'Prepare for liftoff, knowledge duel activated!\nTwo astronauts face true-false question challenges. Correct answers propel your rocket toward the stars, wrong answers make you spin in place~ Who can be the first to fly beyond the atmosphere and become a knowledge astronaut?',
  
  // Pick Wheel description
  pickGameTitle: 'Spin the Wheel',
  pickGameDesc: 'Spin the wheel of destiny!\nSupports individual picking, group picking, or custom options. Make choices more fun and fair. Wheel spins, answer reveals!',
  
  // Punch Board description
  punchBoardGameTitle: 'Punch Board',
  punchBoardGameDesc: 'Punch through to surprises!\nEach hole hides different surprises. Break through the surface to explore content. Supports various board sizes and animation effects, making choices full of anticipation!',

  // More Game Management description
  moreManagementTitle: 'More Game Management',
  moreManagementDesc: 'Manage your game settings and content!\nHere you can view detailed settings for all games, manage game questions, adjust game parameters, and make your classroom games more personalized and enriched!',

  // Snake description
  snakeGameTitle: 'Vocabulary Snake',
  snakeGameDesc: 'Classic returns! Knowledge-based Snake is here~\nControl the snake through the maze, eat the food with correct answers to grow longer, but watch out for walls and yourself! Test your reflexes and knowledge!',

  // Maze description
  mazeGameTitle: 'Maze',
  mazeGameDesc: 'Adventure awaits! Challenge the knowledge maze~\nFind the correct path in the maze. The fastest to reach the exit becomes the maze master!',

  // Button text
  play: 'Start Game',
  enterManagement: 'Enter Management',

  // School version authorization warning
  schoolVersionWarning: 'School has not obtained campus version authorization!',

  // Common game settings (used by multiple games)
  useHiTeachRoster: 'Use HiTeach Current Class Roster',
  rosterEmptyWarning: 'Roster is empty, using default anonymous mode',

  // Push related
  pushSuccess: 'Push successful',
  pushFailed: 'Push failed: {message}',
  tokenRefreshing: 'Refreshing authentication...',

  // View scores related
  viewScores: 'View Scores',
  noActivityPushed: 'No activity pushed yet',
  canViewScores: 'Push successful! You can click the View Scores button to see student submissions',

  // Activity limit
  activityLimitExceeded: 'Activity limit reached ({maxLimit} activities). Please delete some activities in Game Management and try again!'
}